import { c as _c } from "react/compiler-runtime";
import React from "react";
import { BLOCKS, INLINES, Document, BLOCKS as BLOCKS_TYPES } from "@contentful/rich-text-types";
import { documentToReactComponents, Options } from "@contentful/rich-text-react-renderer";
interface Reference {
  __typename?: string;
  contentfulId: string;
  image: {
    file: {
      url: string;
    };
  };
  altText?: string;
  caption?: string;
}
interface RichTextRendererProps {
  raw: string;
  references: Reference[];
  componentClass: string;
}
export const RichTextRenderer = t0 => {
  const $ = _c(9);
  const {
    raw,
    references,
    componentClass
  } = t0;
  if (!raw) {
    return null;
  }
  let t1;
  if ($[0] !== componentClass || $[1] !== raw || $[2] !== references) {
    const parsedContent = typeof raw === "string" ? JSON.parse(raw) : raw;
    let t2;
    if ($[4] !== componentClass || $[5] !== references) {
      t2 = node => {
        const id = node.data?.target?.sys?.id;
        const image = references.find(ref => ref.contentfulId === id);
        if (!image || !image.image?.file?.url) {
          return null;
        }
        return <figure key={id} className={`${componentClass}__image`}><img src={image.image?.file?.url} alt={image.altText || ""} />{image.caption && <figcaption>{image.caption}</figcaption>}</figure>;
      };
      $[4] = componentClass;
      $[5] = references;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    const options = {
      renderNode: {
        [BLOCKS_TYPES.EMBEDDED_ENTRY]: t2,
        [BLOCKS.PARAGRAPH]: _temp,
        [BLOCKS.HEADING_2]: _temp2,
        [BLOCKS.HEADING_3]: _temp3,
        [INLINES.HYPERLINK]: _temp4
      }
    };
    t1 = documentToReactComponents(parsedContent, options);
    $[0] = componentClass;
    $[1] = raw;
    $[2] = references;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <>{t1}</>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
function _temp(_, children) {
  return <p>{children}</p>;
}
function _temp2(__0, children_0) {
  return <h2>{children_0}</h2>;
}
function _temp3(__1, children_1) {
  return <h3>{children_1}</h3>;
}
function _temp4(node_0, children_2) {
  const url = node_0.data.uri;
  return <a href={url} target="_blank" rel="noopener noreferrer">{children_2}</a>;
}